import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

/**
 * 🔹 Get Payment Overview
 * Fetches KPI cards, revenue trend, source & status charts, weekly trend, and recent transactions.
 * Matches the "PaymentDashboard" Vue component requirements.
 */
export async function getPaymentReport(user_id, range = "last_7_days", source = "all", status = "all") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("range", range);
    fd.append("source", source);
    fd.append("status", status);

    const response = await axios.post(`${apiBaseUrl}payment/get_payment_overview`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getPaymentOverview error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to load payment overview",
      data: {},
    };
  }
}
export function downPaymentReport(user_id, range = "last_7_days", source = "all", status = "all") {
  try {
    const params = new URLSearchParams({
      user_id: user_id,
      range: range,
      source: source,
      status: status,
    }).toString();

    window.open(`${apiBaseUrl}payment/export_payment_csv?${params}`, "_blank");

  } catch (error) {
    console.error("getPaymentOverview error:", error);

  }
  return "";
}

/* -----------------------------------------
   1️⃣ CREATE PAYMENT
----------------------------------------- */
export async function createPayment(data) {
  try {
    const form = new FormData();
    form.append("pay_data", btoa(JSON.stringify(data)));

    const res = await axios.post(apiBaseUrl + "payment/create_payment", form);
    return res.data;
  } catch (e) {
    return { status: false, success: "Server Error" };
  }
}

/* -----------------------------------------
   2️⃣ GET Payment by ID
----------------------------------------- */
export async function getPayment(pay_id) {
  try {
    const form = new FormData();
    form.append("pay_id", pay_id);

    const res = await axios.post(apiBaseUrl + "payment/get_payment", form);
    return res.data;
  } catch (e) {
    return { status: false, success: "Server Error" };
  }
}

/* -----------------------------------------
   3️⃣ LIST Payments (filters + search + pagination)
----------------------------------------- */
export async function listPayments(pay_user, pay_invoice, search = "", page_no = 0) {
  try {
    const form = new FormData();
    form.append("pay_user", pay_user);
    form.append("search", search);
    form.append("page_no", page_no);
    form.append("pay_invoice", pay_invoice);

    const res = await axios.post(apiBaseUrl + "payment/list_payments", form);
    return res.data;
  } catch (e) {
    return { status: false, success: "Server Error" };
  }
}

/* -----------------------------------------
   4️⃣ UPDATE Payment
----------------------------------------- */
export async function updatePayment(data) {
  try {
    const form = new FormData();
    form.append("pay_data", btoa(JSON.stringify(data)));

    const res = await axios.post(apiBaseUrl + "payment/update_payment", form);
    return res.data;
  } catch (e) {
    return { status: false, success: "Server Error" };
  }
}

/* -----------------------------------------
   5️⃣ DELETE Payment
----------------------------------------- */
export async function deletePayment(pay_id) {
  try {
    const form = new FormData();
    form.append("pay_id", pay_id);

    const res = await axios.post(apiBaseUrl + "payment/delete_payment", form);
    return res.data;
  } catch (e) {
    return { status: false, success: "Server Error" };
  }
}

